/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prefer-stateless-function */

import PropTypes from 'prop-types'
import React, { Component } from 'react'
import HandoverHistoryItem from './HandoverHistoryItem'

export default class HandoversHistory extends Component {
  render() {
    const { handovers, onHandoverOpen } = this.props
    return (
      <div>
        {Object.keys(handovers).map((date, i) => {
          const currentHandoversList = handovers[date]
          return (
            <div key={i}>
              <h2 style={styles.heading}>{date}</h2>
              <div className="lmc-theme-gradient" style={styles.divider} />
              {currentHandoversList.map((handover) => (
                <HandoverHistoryItem
                  onOpen={() => onHandoverOpen(handover.id)}
                  handover={handover}
                  key={handover.id}
                />
              ))}
            </div>
          )
        })}
      </div>
    )
  }
}

const styles = {
  divider: {
    height: 2,
    marginBottom: 12,
    width: '100%'
  },
  heading: {
    marginTop: 30,
    marginBottom: '0.3em',
    fontWeight: 300,
    textOverflow: 'ellipsis',
    hyphens: 'auto'
  }
}

HandoversHistory.propTypes = {
  handovers: PropTypes.object.isRequired,
  onHandoverOpen: PropTypes.func.isRequired
}
